// @flow

/**
 * @module Constants/Quickpay
 * @desc Quickpay Constants
 */

import keyMirror from 'keymirror';

/**
 * @constant {Object} AuthConstants
 * @memberof Auth
 */
export const QuickpayConstants = keyMirror({
  GET_QUICKPAY: 'GET_QUICKPAY',
  GET_PAYMENT_ACCOUNTS: 'GET_PAYMENT_ACCOUNTS',
  ADD_PAYMENT_ACCOUNT: 'ADD_PAYMENT_ACCOUNT',
  GET_STATUS: 'GET_STATUS',
  MAKE_QUICKPAY_PAYMENT: 'MAKE_QUICKPAY_PAYMENT',
  GET_AUTOPAYS: 'GET_AUTOPAYS',
  SCHEDULE_AUTOPAY: 'SCHEDULE_AUTOPAY',
  VALIDATE_BANK_ROUTING_NUMBER_QUICKPAY: 'VALIDATE_BANK_ROUTING_NUMBER_QUICKPAY',
  UPDATE_DEBIT_CARD: 'UPDATE_DEBIT_CARD',
  SUBMIT_BORROWER_SELF_IDENTIFICATION: 'SUBMIT_BORROWER_SELF_IDENTIFICATION',
  GET_COLLATERAL_SUMMARY: 'GET_COLLATERAL_SUMMARY',
  GET_COLLATERAL_REQUIRED: 'GET_COLLATERAL_REQUIRED',
  GET_LOAN_SETUP: 'GET_LOAN_SETUP',
});
